import script from "./AddWorksSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AddWorksSearch.vue?vue&type=script&setup=true&lang=js"

import "./AddWorksSearch.vue?vue&type=style&index=0&id=662397e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662397e5"]])

export default __exports__